import { useEffect, useRef } from 'react';

const steps = [
  {
    num: '01',
    icon: 'ri-list-check-2',
    title: 'Hizmeti Seçin',
    desc: 'Koltuk yıkama, yatak yıkama, sandalye yıkama veya petek temizliği — hangi hizmete ihtiyacınız var?',
  },
  {
    num: '02',
    icon: 'ri-calendar-check-line',
    title: 'Randevu Oluşturun',
    desc: 'WhatsApp veya formumuz aracılığıyla adres ve tarih bilginizi bizimle paylaşın.',
  },
  {
    num: '03',
    icon: 'ri-team-line',
    title: 'Ekibimiz Gelsin',
    desc: 'Uzman ekibimiz tüm ekipmanıyla kapınıza gelir, profesyonel temizliği gerçekleştirir.',
  },
];

export default function HowItWorks() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) el.classList.add('opacity-100', 'translate-y-0'); },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="how-it-works" className="w-full bg-[#1a1a1a] py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4">
        <div
          ref={ref}
          className="opacity-0 translate-y-8 transition-all duration-700"
        >
          {/* Header */}
          <div className="text-center mb-14">
            <span className="inline-block text-emerald-400 font-semibold text-sm uppercase tracking-widest mb-3">
              Nasıl Çalışır
            </span>
            <h2
              className="text-3xl md:text-5xl font-extrabold text-white leading-tight"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              3 Adımda Tertemiz Ev
            </h2>
            <p className="text-gray-400 mt-3 text-base md:text-lg max-w-xl mx-auto">
              Hızlı, güvenilir ve evden çıkmadan teslim.
            </p>
          </div>

          {/* Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
            {/* Connector line */}
            <div className="hidden md:block absolute top-14 left-[16.66%] right-[16.66%] h-0.5 bg-emerald-500/20" />

            {steps.map((s) => (
              <div key={s.num} className="flex flex-col items-center text-center group">
                <div className="relative mb-6">
                  <div className="w-28 h-28 flex items-center justify-center bg-white/5 border border-emerald-500/30 rounded-full group-hover:bg-emerald-500/10 transition-colors">
                    <span className="w-10 h-10 flex items-center justify-center">
                      <i className={`${s.icon} text-emerald-400 text-4xl`} />
                    </span>
                  </div>
                  <span className="absolute -top-2 -right-2 w-9 h-9 flex items-center justify-center bg-emerald-500 text-white text-xs font-extrabold rounded-full">
                    {s.num}
                  </span>
                </div>
                <h3
                  className="text-white font-bold text-xl mb-3"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  {s.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed max-w-xs">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
